import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { Warning } from '@phosphor-icons/react';
import {
    systemDesignFixFabLabel,
    type SystemDesignMissingItem,
    type SystemDesignMissingItemId,
} from './systemDesignMissingItems';

export type SystemDesignFixFabProps = {
    items: SystemDesignMissingItem[];
    onFixItem: (id: SystemDesignMissingItemId) => void;
    onScrollToSection?: () => void;
};

export const SystemDesignFixFab: React.FC<SystemDesignFixFabProps> = ({
    items,
    onFixItem,
    onScrollToSection,
}) => {
    const handlePrimaryClick = useCallback(() => {
        onScrollToSection?.();
        const first = items[0];
        if (first) onFixItem(first.id);
    }, [items, onFixItem, onScrollToSection]);

    if (items.length === 0 || typeof document === 'undefined') return null;

    const label = systemDesignFixFabLabel(items);

    return createPortal(
        <div className="obd-system-design-fix-fab" role="complementary" aria-label="Fix missing system design steps">
            <button
                type="button"
                className="obd-system-design-fix-fab__pill"
                onClick={handlePrimaryClick}
            >
                <Warning size={14} weight="fill" aria-hidden />
                <span>{label}</span>
            </button>
            <button
                type="button"
                className="obd-system-design-fix-fab__btn"
                onClick={handlePrimaryClick}
                aria-label={`Fix ${items.length} missing system design step${items.length === 1 ? '' : 's'}`}
            >
                <Warning size={28} weight="fill" aria-hidden />
            </button>
        </div>,
        document.body,
    );
};
